export const priceFormat = (value: string | number | null | undefined) => {
  if (!value) return '0.00';

  const number = typeof value === 'string' ? Number(value.trim().replace(',', '.')) : value;

  return number.toFixed(2);
};
